import { MenuItemType, MenuItemSchema } from "@/schemas/index";
import { LocalizationAvailableLangType } from "@/schemas/index";
import { fetchMockupMenuItems } from "./mockup/menu-mockup";

export interface ServiceMenuApiType {
  fetchDefaultMenu: (
    currentLang: LocalizationAvailableLangType,
    jwtToken?: string,
  ) => Promise<MenuItemType[]>;
  fetchAdvancedMenu: (
    currentLang: LocalizationAvailableLangType,
    jwtToken?: string,
  ) => Promise<MenuItemType[]>;
  fetchFooterMenu: (
    currentLang: LocalizationAvailableLangType,
    jwtToken?: string,
  ) => Promise<MenuItemType[]>;
  fetchUserMenu: (
    currentLang: LocalizationAvailableLangType,
    jwtToken?: string,
  ) => Promise<MenuItemType[]>;
}

export const serviceMenuApi: ServiceMenuApiType = {
  fetchDefaultMenu: (currentLang, jwtToken) =>
    Promise.resolve(
      fetchMockupMenuItems(currentLang, ["header", "guest"], jwtToken).map(
        (item: any) => MenuItemSchema.parse(item),
      ),
    ),
  fetchAdvancedMenu: (currentLang, jwtToken) =>
    Promise.resolve(
      fetchMockupMenuItems(currentLang, ["header"], jwtToken).map((item: any) =>
        MenuItemSchema.parse(item),
      ),
    ),
  fetchUserMenu: (currentLang, jwtToken) =>
    Promise.resolve(
      fetchMockupMenuItems(currentLang, ["user"], jwtToken).map((item: any) =>
        MenuItemSchema.parse(item),
      ),
    ),
  fetchFooterMenu: (currentLang, jwtToken) =>
    Promise.resolve(
      fetchMockupMenuItems(currentLang, ["footer"], jwtToken).map((item: any) =>
        MenuItemSchema.parse(item),
      ),
    ),
};
